import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssetManagement,AssetSourceConfigurationItem } from '@aptsi-types';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandlingService } from 'src/app/shared/errorHandling/errorHandling.service';
import { API_ENDPOINTS } from 'src/app/features/asset-management/asset-management-api-endpoints';


@Injectable({
  providedIn: 'root'
})
export class SystemAssetSourceService {
  private readonly systemAssetSourceUrl = environment.apiUrl;

  constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingService) { }



    FetchSystemAssetSources(currentPage: number): Observable<AssetManagement[]> {
    return this.http.post<AssetManagement[]>(`${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.FETCH_SYSTEM_ASSET_SOURCES}`, { currentPage })
      .pipe(
        map(response => response),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

    FetchSysteAssetSourcesSearch( currentPage: number, searchText: String, filterByHeader: String): Observable<AssetManagement[]> {
      return this.http.post<AssetManagement[]>(`${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.FETCH_SYSTEM_ASSET_SOURCES_SEARCH}`, { currentPage, searchText, filterByHeader })
        .pipe(
          map(response => response),
          catchError(error => this.errorHandlingService.handleError(error))
        );
    }

  TestAssetSourceConnection(
    assetSource: string,
    url: string,
    connectionDetails: AssetSourceConfigurationItem[]
  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.TESTASSETSOURCECONNECTION}`,
      {
        assetSource,
        url,
        connectionDetails
      }
    ).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }



  // ------------------------------------------------------------------
  // 1. Import Assets during System Asset Source Setup
  // ------------------------------------------------------------------
  ImportSystemAssetsDuringSetup(
    organizationId: string,
    assetSourceName: string,
    assetSourceType: string,
    assetSource: string,
    importedBy: string,
    url: string,
    connectionDetails: AssetSourceConfigurationItem[],
    importedByKeycloakId: string
  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.IMPORT_SYSTEM_ASSETS_DURING_SETUP}`,
      {
        organizationId,
        assetSourceName,
        assetSourceType,
        assetSource,
        importedBy,
        url,
        connectionDetails,
        importedByKeycloakId
      }
    ).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }


  // ------------------------------------------------------------------
  // 2. Read Imported Assets from Staging Table (with pagination)
  // ------------------------------------------------------------------
  ReadSystemAssetsFromStagingTable(
    importedByKeycloakId: string,
    assetSourceName: string
  ): Observable<AssetManagement[]> {
    return this.http.post<AssetManagement[]>(
      `${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.READ_SYSTEM_ASSETS_FROM_STAGING_TABLE}`,
      {
        importedByKeycloakId,
        assetSourceName
      }
    ).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }


  // ------------------------------------------------------------------
  // 3. Complete System Asset Capture / Setup
  // ------------------------------------------------------------------
  CompleteSystemAssetCapture(
    assetSourceName: string,
    assetType: string,
    assetSourceType: string,
    assetSource: string,
    organizationId: string,
    url: string,
    assetSourceConfigurationAttributeDTOs: AssetSourceConfigurationItem[],
    isAssetImport: string,
    importedByKeycloakId: string
  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.COMPLETE_SYSTEM_ASSET_SETUP}`,
      {
        assetSourceName,
        assetType,
        assetSourceType,
        assetSource,
        organizationId,
        url,
        assetSourceConfigurationAttributeDTOs,
        isAssetImport,
        importedByKeycloakId
      }
    ).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }


  // ------------------------------------------------------------------
  // 4. Update System Asset Capture / Setup
  // ------------------------------------------------------------------
  UpdateSystemAssetSourceDetails(
    assetSourceId: string,
    assetSourceName: string,

  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.UPDATE_SYSTEM_ASSET_SOURCE_DETAILS}`,
      {
        assetSourceId,
        assetSourceName

      }
    ).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }


  FetchSystemAssetSourceDetails(assetSourceId: string): Observable<AssetManagement> {
    return this.http.post<AssetManagement>(`${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.FETCH_SYSTEM_ASSET_SOURCE_DETAILS}`, { assetSourceId })
      .pipe(
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  deleteAssetSource(assetSourceId: string): Observable<AssetManagement> {
    return this.http.post<AssetManagement>(`${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.DELETE_ASSETSOURCE}`, { assetSourceId })
      .pipe(
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

UpdateSystemAssetSourceConnectionDetails(
  assetSourceId: string,
  url: string,
  assetSourceConfigurationAttributeDTOs: AssetSourceConfigurationItem[]
): Observable<{ message: string }> {
  return this.http.post<{ message: string }>(
    `${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.UPDATE_SYSTEM_ASSET_SOURCE_CONNECTION_DETAILS}`,
    {
      assetSourceId,
      url,
      assetSourceConfigurationAttributeDTOs
    }
  ).pipe(
    catchError(error =>
      this.errorHandlingService.handleError(error)
    )
  );
}

  fetchSystemAssetSourceConnectionDetails(assetSourceId: string): Observable<AssetManagement> {
    return this.http.post<AssetManagement>(`${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.FETCH_SYSTEM_ASSET_SOURCE_CONNECTION_DETAILS}`, { assetSourceId })
      .pipe(
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }


  CompleteSystemAssetCaptureFromFIle(
    assetSourceName: string,
    assetType: string,
    assetSourceType: string,
    assetSource: string,
    organizationId: string,
    isAssetImport: string,
    importedByKeycloakId: string
  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.COMPLETE_SYSTEM_ASSET_SETUP_USING_FILE}`,
      {
        assetSourceName,
        assetType,
        assetSourceType,
        assetSource,
        organizationId,
        isAssetImport,
        importedByKeycloakId
      }
    ).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }

  importSystemAssetsFromFileDuringSetup(
    file: File,
    organizationId: string,
    assetSourceName: string,
    assetSourceType: string,
    assetSource: string,
    importedBy: string,
    importedByKeycloakId: string
  ): Observable<{ message: string }> {
    const formData = new FormData();
    formData.append("file", file, file.name);
    formData.append("organizationId", organizationId);
    formData.append("assetSourceName", assetSourceName);
    formData.append("assetSourceType", assetSourceType);
    formData.append("assetSource", assetSource);
    formData.append("importedBy", importedBy);
    formData.append("importedByKeycloakId", importedByKeycloakId);
    return this.http.post<{ message: string }>(
      `${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.IMPORT_SYSTEM_ASSETS_FROM_FILE_DURING_SETUP}`,
      formData
    ).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }


    ImportSystemAssetsFromFile(
    file: File,
    assetSourceId: string
  ): Observable<{ message: string }> {
    const formData = new FormData();
    formData.append("file", file, file.name);
    formData.append("assetSourceId", assetSourceId);
    return this.http.post<{ message: string }>(
      `${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.IMPORT_SYSTEM_ASSETS_FROM_FILE}`,
      formData
    ).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }


  FetchSystemAssetsFromFile(assetSourceId: string): Observable<AssetManagement> {
    return this.http.post<AssetManagement>(
      `${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.FETCH_SYSTEM_ASSETS_FROM_FILE}`,
      {
        assetSourceId
      }
    ).pipe(
      catchError(error =>
        this.errorHandlingService.handleError(error)
      )
    );
  }





  createManualSystemAsset(

    systemAssetName: string,
    systemAssetDescription: string,
    systemAssetOwner: string,
    systemAssetStatus: string,
    systemAssetEndpoint: string,
    systemAssetLifecycleStatus: string,
    systemAssetBusinessValue: string,
    dataClassification: string,
    importedBy: string,
    importedByKeycloakId: string
  ): Observable<AssetManagement> {
    return this.http.post<AssetManagement>(
      `${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.CREATE_MANUAL_SYSTEM_ASSET}`,
      {

        systemAssetName,
        systemAssetDescription,
        systemAssetOwner,
        systemAssetStatus,
        systemAssetEndpoint,
        systemAssetLifecycleStatus,
        systemAssetBusinessValue,
        dataClassification,
        importedBy,
        importedByKeycloakId
      }
    ).pipe(
      catchError(error =>
        this.errorHandlingService.handleError(error)
      )
    );
  }


  updateManualSystemAsset(
    systemAssetId: string,
    systemAssetDescription: string,
    systemAssetOwner: string,
    systemAssetStatus: string,
    systemAssetEndpoint: string,
    systemAssetLifecycleStatus: string,
    systemAssetBusinessValue: string,
    dataClassification: string,
    importedBy: string,
    importedByKeycloakId: string
  ): Observable<AssetManagement> {
    return this.http.post<AssetManagement>(
      `${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.UPDATE_MANUAL_SYSTEM_ASSET}`,
      {
        systemAssetId,
        systemAssetDescription,
        systemAssetOwner,
        systemAssetStatus,
        systemAssetEndpoint,
        systemAssetLifecycleStatus,
        systemAssetBusinessValue,
        dataClassification,
        importedBy,
        importedByKeycloakId
      }
    ).pipe(
      catchError(error =>
        this.errorHandlingService.handleError(error)
      )
    );
  }

  getManualSystemAsset(systemAssetId: string): Observable<AssetManagement> {
    return this.http.post<AssetManagement>(
      `${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.GET_MANUAL_SYSTEM_ASSET}`,
      {
        systemAssetId
      }
    ).pipe(
      catchError(error =>
        this.errorHandlingService.handleError(error)
      )
    );
  }

  ImportSystemAssetsByAssetSource(
    assetSourceId: string,

  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.IMPORT_SYSTEM_ASSETS_BY_ASSET_SOURCE_ID}`,
      {
        assetSourceId,

      }
    ).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }

    FetchSystemAssetsByAssetSourceID(
      assetSourceId: string,
      currentPage: number
    ): Observable<AssetManagement[]> {
      return this.http.post<AssetManagement[]>(
        `${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.FETCH_SYSTEM_ASSETS_BY_ASSET_SOURCE_ID}`,
        { assetSourceId, currentPage }
      ).pipe(
        catchError(error =>
          this.errorHandlingService.handleError(error)
        )
      );
    }
  
    FetchSystemAssetsByAssetSourceIDSearch(assetSourceId: string, currentPage: number, searchText: String, filterByHeader: String): Observable<AssetManagement[]> {
      return this.http.post<AssetManagement[]>(`${this.systemAssetSourceUrl}${API_ENDPOINTS.ASSETCAPTURE.SEARCH_SYSTEM_ASSETS_BY_ASSET_SOURCE_ID}`, { assetSourceId, currentPage, searchText, filterByHeader })
        .pipe(
          map(response => response),
          catchError(error => this.errorHandlingService.handleError(error))
        );
    }


}

